import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { BULK_IMPORT_ITEMS_QUERY_KEY } from "../bulk-imports/useBulkImportItemsQuery";
import { BULK_IMPORT_QUERY_KEY } from "../bulk-imports/useBulkImportQuery";
import { BULK_IMPORTS_QUERY_KEY } from "../bulk-imports/useBulkImportsQuery";

/**
 * Hook to invalidate all bulk-import queries.
 * Use this after creating a new import or when items are expected to change.
 */
export const useInvalidateBulkImports = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [BULK_IMPORTS_QUERY_KEY]
    });
    await queryClient.invalidateQueries({
      queryKey: [BULK_IMPORT_QUERY_KEY]
    });
    await queryClient.invalidateQueries({
      queryKey: [BULK_IMPORT_ITEMS_QUERY_KEY]
    });
  }, [queryClient]);
};
